import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';

const WhySecTwo = ({ className = '' }) => {
  const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.3
    });
  const { t } = useTranslation();
  const counters = t('sections.whySecTwo.counters', { returnObjects: true, defaultValue: [
    { number: '5', suffix: 'k+', text: 'Projects Completed', themeColor: '#069845' },
    { number: '150', suffix: 'k+', text: 'Customers Globally', themeColor: '#E0009B' },
    { number: '95', suffix: '%', text: 'Client Retention Rate', themeColor: '#F0A230' },
    { number: '25', suffix: '+', text: 'Years Of Experience', themeColor: '#8F54FF' }
  ] });

  return (
    <div className={`${className}`}>
      <div
            className="shape-mockup bg-gradient-shape1 why-bg-gradient2"
            data-top="auto"
            data-bottom="30%"
            data-left="3%" 
        />
      <div className="container">
        <div className="title-area mb-40 text-center">
          <span className="sub-title style2" data-cue="slideInUp">{t('sections.whySecTwo.sub_title','Why Choose Us')}</span>
          <h2 className="sec-title" data-cue="slideInUp" data-delay="100" dangerouslySetInnerHTML={{ __html: t('sections.whySecTwo.title','Forging The Path to <br /> Cybersecurity Leadership') }} />
        </div>
        <div className="row gy-30 justify-content-between align-items-center">
          <div className="col-lg-auto text-center order-lg-2">
            <div className="why-img-box2" data-cue="slideInUp">
              <img src="assets/img/normal/why2-1.png" alt="img" />
            </div>
          </div>
          <div className="col-lg-auto col-sm-6 order-lg-1">
            {counters.slice(0, 2).map((counter, index) => (
              <div className="counter-card style2" data-cue="slideInUp" key={index}>
                <div className="media-body">
                  <h2 className="box-number">
                    <span ref={ref}>
                        {inView && (
                            <CountUp
                                start={0}
                                end={counter.number}
                                duration={2}
                                separator=","
                                suffix={counter.suffix}
                                className="count-up-text"
                            />
                        )}
                    </span>
                  </h2>
                  <span className="box-text" data-theme-color={counter.themeColor}>
                    {counter.text}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="col-lg-auto col-sm-6 order-lg-3">
            {counters.slice(2, 4).map((counter, index) => (
              <div className="counter-card style2" data-cue="slideInUp" key={index}>
                <div className="media-body">
                  <h2 className="box-number">
                    <span ref={ref}>
                        {inView && (
                            <CountUp
                                start={0}
                                end={counter.number}
                                duration={2}
                                separator=","
                                suffix={counter.suffix}
                                className="count-up-text"
                            />
                        )}
                    </span>
                  </h2>
                  <span className="box-text" data-theme-color={counter.themeColor}>
                    {counter.text}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhySecTwo;